import { normalizeUser, type User } from '@/data'
import api from '.'
import type { UserPayload } from './createUser'

type UpdateUserPayload = Partial<UserPayload>

export async function updateUser(
  id: string,
  payload: UpdateUserPayload,
): Promise<User> {
  const res = await api.patch(`/${id}`, payload)
  return normalizeUser(res.data.data)
}
